import { createAction } from "@reduxjs/toolkit";

// this action resets everything to intial state, for use on logout
export const resetState = createAction('RESET_STATE');